import Choices from "choices.js";

window.choices = (element, count = 8, removeItemButton = true) => {
	return new Choices(element, {
		maxItemCount: count,
		removeItemButton: removeItemButton,
		duplicateItemsAllowed: false,
		searchPlaceholderValue: "Search",
		placeholder: true

	})
}

document.addEventListener("DOMContentLoaded", function () {
	let choicesEl = document.getElementById('choices_container')
	if (typeof (choicesEl) != 'undefined' && choicesEl != null) {
		new Choices(choicesEl, {
			maxItemCount: 20,
			removeItemButton: true,
			duplicateItemsAllowed: false,
			searchPlaceholderValue: "Search",
			placeholder: true

		})
	}
})
